import { render, staticRenderFns } from "./newMunicipality.vue?vue&type=template&id=5dd52ccc&"
import script from "./newMunicipality.vue?vue&type=script&lang=js&"
export * from "./newMunicipality.vue?vue&type=script&lang=js&"
import style0 from "./newMunicipality.vue?vue&type=style&index=0&id=5dd52ccc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports